import axios, {AxiosHeaderValue, AxiosRequestConfig, HeadersDefaults} from 'axios'
import {DateTime} from 'luxon'

import {auth} from './firebase'
import {getAuthToken, setAuthToken} from './local-storage'

const axiosInstance = axios.create()

type MakeRequestHeadersHelper = (_headers?: AxiosRequestConfig['headers']) => Promise<AxiosRequestConfig['headers']>
export const makeRequestHeaders: MakeRequestHeadersHelper = async (headers = {}) => {
  const tokenData = getAuthToken()
  let token = ''
  const targetDate = tokenData?.expirationTime
    ? DateTime.fromHTTP(tokenData.expirationTime)
    : DateTime.now()
  const now = DateTime.now().plus({minute: 2})
  if (tokenData && now <= targetDate) {
    token = tokenData.token
  } else {
    const updatedTokenData = await auth.currentUser?.getIdTokenResult(true)
    if (updatedTokenData) {
      setAuthToken(updatedTokenData)
      token = updatedTokenData.token
    }
  }
  const sessionHeaders: AxiosRequestConfig['headers'] = {}
  if (token) {
    sessionHeaders.Authorization = `Bearer ${token}`
  }
  return {...sessionHeaders, ...headers}
}

export const sendRequest = async <T>(
  method: 'delete' | 'get' | 'patch' | 'post' | 'put',
  endpoint: string,
  data?: any,
  options = {} as AxiosRequestConfig,
) => {
  const headers = await makeRequestHeaders(options.headers)
  const token = headers?.Authorization as string || ''
  // Added remove headers.Authorization because it is not deletes properly and makes request with old token
  if (token) {
    axiosInstance.defaults.headers = headers as HeadersDefaults & {[key: string]: AxiosHeaderValue}
    // eslint-disable-next-line
  } else if (axiosInstance.defaults.headers.common?.Authorization) {
    delete axiosInstance.defaults.headers.common.Authorization
  } else if (axiosInstance.defaults.headers.Authorization) {
    delete axiosInstance.defaults.headers.Authorization
  }

  if (method === 'get' || method === 'delete') {
    return axiosInstance[method]<T>(endpoint, {...options})
  }

  return axiosInstance[method]<T>(endpoint, data, {...options})
}
